import React, { useState, useCallback, useEffect } from "react";

import {
    Box,
    Button,
    // Tabs,
    Tab,
    TabPanel,
    Divider,
    TextField,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    FormHelperText,
    Select,
    FormControl,
    InputLabel,
    InputAdornment,
    MenuItem,
    Card,
    styled,
    List,
    ListItem,
    Chip,
    Table,
    TableCell,
    TableContainer,
    TableBody,
    TableHead,
    TableRow,
    ListItemText,
    OutlinedInput,
    Checkbox,
    Tooltip,
    IconButton
} from '@mui/material';

import dayjs from "dayjs";

import { grey } from "@mui/material/colors";

import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';

import CommonBreadcumbs from "../../../../../components/common/CommonBreadcumbs"
import CommonSectionHeader from "../../../../../components/common/CommonSectionHeader";
import CommonRestricted from '../../../../../components/common/CommonRestricted';
import { CommonIcons, icons } from "../../../../../components/common/CommonIcons";
// import { spliceString } from "../../../../../utils/formatString";

import { useSystemPrompt } from "../../../../../hooks/useSystemPrompt";
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../../../hooks/usePermissions';

import CommonDialog from "../../common/CommonDialog"
import SearchCustomerMarkings from "../../dialog/SearchCustomerMarkings"

import { useTranslations } from "../../../../../hooks/useTranslations";

import { useSystemRoutes, routeTypes } from '../../../../../hooks/useSystemRoutes';
import { useAppContextFeatures } from '../../../../../context/AppContext';

import {
    validationSchema,
    initialValues,
    initialProductValues,
    initialItemValues,
    productInjectionProps,
    paymentTypes as productPaymentTypes,
    getUniqueProductCodeLong,
    getUniqueProductCodeShort,
    useProduct
} from "../../../hooks/model/useProduct"

import {
    defaultUom
} from "../../../hooks/model/useProductItem"

import {
    markingInjectionProps
} from "../../../hooks/model/useMarking"

import {
    useWorker
} from "../../../hooks/model/useWorker"

import { useSystemHead, headTitles } from '../../../../../hooks/useSystemHead';

import { useAuthAccess } from "../../../../../hooks/useAuthAccess";

// import AddProductItems from "./section/AddProductItems";
import AddProductItemsV2 from "./section/AddProductItemsV2";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));


export default function NewProduct({
    routeType
}) {

    const { t } = useTranslations({ ns: ["_@products", "_@parcel", "_prompt", "common", "_common"] })

    const { promptMessage } = useSystemPrompt();

    const { listWorkers } = useWorker({ routeType })
    const { addProduct } = useProduct({ routeType })

    const { isPermissionAllow } = usePermissions(routeType, scopeIds.product.id, scopeTypes.product.product.id)

    const { getAvailableLocations, authData } = useAuthAccess();
    const availableLocations = getAvailableLocations()

    const [openDialog, setOpenDialog] = useState({
        status: false,
        title: ``,
        productIndex: 0,
        courierTrackingNo: "",
        data: {}
    })

    // console.log('authData, authData', authData)

    let authProfileUserId = authData?.profile?.user?.id

    const { setSystemLoading } = useAppContextFeatures();
    const navigate = useNavigate();

    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    // const [dataWorkers, setDataWorkers] = useState()
    const [dataAvailableWorkers, setDataAvailableWorkers] = useState()

    const fetchWorkers = async ({ loadLocationId }) => {

        try {

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [],
                sortInfo: {
                    id: 'username',
                    dir: ''
                },
                // dataTypes: ["location"]
            }

            // const result = await listWorkers(props)
            const { data } = await listWorkers({
                props
            })

            let _workers = []

            // let allWorkers = result?.data?.workers ? result.data.workers : []
            let allWorkers = data

            if (allWorkers.length) {
                allWorkers.forEach(i => {
                    const exists = i?.locations.filter(i2 => i2.id === loadLocationId)

                    if (exists.length > 0) {
                        _workers.push(i)
                    }
                })
            }

            setDataAvailableWorkers(_workers)

            // setDataWorkers()

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            console.log('currentValues', currentValues)

            let _products = currentValues?.products.map(i => ({

                signUserId: i.signUserId,
                signUserDisplay: i.signUserDisplay,

                supplierContact: i.supplierContact,
                supplierName: i.supplierName,
                supplierPurchaseNumber: i.supplierPurchaseNumber,
                companyPurchaseNumber: i.purchaseNumber,
                prepaidDepositAmount: i.prepaidDepositAmount,
                prepaidTransportAmount: i.prepaidTransportAmount,
                paymentType: i.paymentType,

                checkinDateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),

                appPrintPackQty: 0,
                isAppEntry: false, // not added from app device

                courierTrackingNo: i.courierTrackingNo,
                remark: i?.remark ? i.remark : '-',
                items: i.items.map(i2 => ({
                    uomPrice: i2.uomPrice,
                    remark: i2.remark,
                    weight: i2.weight,
                    description: i2.description,
                    width: i2.width,
                    height: i2.height,
                    length: i2.length,
                    cbm: i2.cbm,

                    code: i2.code,
                    handleQty: i2.handleQty,
                    handleQtyPerPackage: i2.handleQtyPerPackage,
                    qty: i2.qty,
                    totalCbm: i2.totalCbm,
                    totalValue: i2.totalValue,
                    totalWeight: i2.totalWeight,
                    // uomId: i2.uomId,
                    // uomDisplay: i2.uomDisplay,
                    uomId: defaultUom.id,
                    // uomDisplay: defaultUom.uomName
                    // uomDisplay: t(defaultUom.value)
                    uomDisplay: i2?.customUomName

                }))
            }))

            let payload = {
                marking: currentValues?.marking,
                locationId: currentValues?.locationId,
                locationDisplay: currentValues?.locationDisplay,
                userBranchId: currentValues?.userBranchId,
                userDisplay: currentValues?.userDisplay,
                userId: currentValues?.userId,
                products: _products
            }

            let response = await addProduct(payload)

            setSystemLoading(false)

            promptMessage(true, `${t("addProductSuccess")}`)
            navigate(getRoute("products/items"))

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }

        setSystemLoading(false)
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue, setValues } = formik;

    // const reUpdateWorker = () => {
    //     let _workers = []

    //     if (dataWorkers) {
    //         dataWorkers.forEach(i => {
    //             const exists = i?.locations.filter(i2 => i2.id === values.locationId)

    //             if (exists.length > 0) {
    //                 _workers.push(i)
    //             }
    //         })
    //     }

    //     setDataAvailableWorkers(_workers)
    // }

    // if only one warehouse available - auto select
    useEffect(() => {

        if (availableLocations.length === 1) {
            // console.log('availableLocations', availableLocations[0])
            setFieldValue(`locationId`, availableLocations[0]?.id)
            setFieldValue(`locationDisplay`, availableLocations[0]?.location_name)

            fetchWorkers({ loadLocationId: availableLocations[0]?.id })

        }

    }, [])

    useEffect(() => {

        // console.log('dataWorkers', values.locationId, dataWorkers)

        fetchWorkers({ loadLocationId: values.locationId })


    }, [values.locationId])

    // useEffect(() => {

    //     let item = {
    //         description: "desc",
    //         remark: "remark",
    //         uomPrice: "20.0",
    //         width: "100",
    //         length: "200",
    //         height: "300",
    //         weight: "9.8",
    //         qty: "20",
    //         handleQty: "10",
    //         handleQtyPerPackage: "200",
    //         cbm: "2.44",
    //         totalValue: "34000",
    //     }

    //     const pValues = {
    //         supplierName: "SupplierName",
    //         supplierContact: "SupplierContact",
    //         supplierPurchaseNumber: "SPO-12345",
    //         purchaseNumber: "CPO-123456",
    //         courierTrackingNo: "YT12324-32432432",
    //         paymentType: productPaymentTypes.b.id,
    //         prepaidDepositAmount: "10.0",
    //         prepaidTransportAmount: "22.1",
    //         signUserId: "1",
    //         signUserDisplay: "111",
    //         remark: "description",
    //         items: [
    //             item,
    //             item
    //         ],
    //     }

    //     let item2 = {
    //         description: "22desc",
    //         remark: "22remark",
    //         uomPrice: "220.0",
    //         width: "20",
    //         length: "270",
    //         height: "23",
    //         weight: "29.8",
    //         qty: "22",
    //         handleQty: "21",
    //         handleQtyPerPackage: "220",
    //         cbm: "22.44",
    //         totalValue: "234000",
    //     }

    //     const pValues2 = {
    //         supplierName: "SupplierName22",
    //         supplierContact: "SupplierContact22",
    //         supplierPurchaseNumber: "SPO-1234522",
    //         purchaseNumber: "CPO-12345622",
    //         courierTrackingNo: "22YT12324-32432432",
    //         paymentType: productPaymentTypes.c.id,
    //         prepaidDepositAmount: "2210.0",
    //         prepaidTransportAmount: "2222.1",
    //         signUserId: "12",
    //         signUserDisplay: "2111",
    //         remark: "222description",
    //         items: [
    //             item2
    //         ],
    //     }

    //     setFieldValue(`products`, [pValues, pValues2])

    // }, [])

    const RenderFormProduct = (props) => {

        let {
            itemValues,
            itemErrors,
            index,
            // handleChange
        } = props

        let errorMessages = []

        if (itemErrors) {
            if (Object.keys(itemErrors).length > 0) {

                // console.log('Object.keys(itemErrors)', Object.keys(itemErrors).length)
                Object.keys(itemErrors).forEach(key => {
                    errorMessages.push(`${key}: ${JSON.stringify(itemErrors[key])}`)
                })

            }
        }

        let grandHandleQty = 0
        let grandPackQty = 0

        itemValues?.items.forEach(row => {

            grandHandleQty += parseInt(row?.handleQty, 10)
            grandPackQty += parseInt(row?.qty, 10)

        })

        return (
            <>
                <Box
                    alignSelf={"center"}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: grey[600],
                        // borderRadius: 1,
                        py: 0.5,
                        px: 2,
                        m: -2,
                        mb: 1
                    }}
                >
                    <Typography
                        sx={{
                            color: grey[100]
                        }}
                    >
                        {`${t('entry')} ${(index + 1)}`}
                    </Typography>
                    <IconButton
                        onClick={() => {

                            if (values.products.length <= 1) {
                                // promptMessage(false, `At least one product is required`)
                                promptMessage(false, `${t("atLeast1ProductIsRequired")}`)
                                return false
                            }

                            setFieldValue(
                                `products`,
                                values.products.filter((i, ind) => ind !== index)
                            )

                            return true
                        }}
                    >
                        <CommonIcons name={icons.close} sx={{ color: grey[100], width: 15, height: 15 }} />
                    </IconButton>
                </Box>
                <Grid container spacing={1}>
                    {
                        errorMessages.length >= 0 &&
                        <Grid item xs={12} sm={12} md={12} alignSelf={"center"}>
                            <Typography
                                color={"error"}
                                sx={{
                                    fontSize: 12,
                                    mt: 0.5
                                }}
                            >
                                {errorMessages.join(", ")}
                            </Typography>
                        </Grid>
                    }
                    <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                        <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            name={`products.${index}.supplierName`}
                            label={t('supplierName')}
                            type="text"
                            variant="outlined"
                            value={itemValues?.supplierName ? itemValues.supplierName : ""}
                            onChange={handleChange}
                            error={Boolean(itemErrors?.supplierName)}
                        // helperText={itemErrors?.supplierName}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                        <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            name={`products.${index}.supplierContact`}
                            label={t('supplierContact')}
                            type="text"
                            variant="outlined"
                            value={itemValues?.supplierContact ? itemValues.supplierContact : ""}
                            onChange={handleChange}
                            error={Boolean(itemErrors?.supplierContact)}
                        // helperText={itemErrors?.supplierContact}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                        <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            name={`products.${index}.courierTrackingNo`}
                            label={t('courierNo')}
                            type="text"
                            variant="outlined"
                            value={itemValues?.courierTrackingNo ? itemValues.courierTrackingNo : ""}
                            onChange={handleChange}
                            error={Boolean(itemErrors?.courierTrackingNo)}
                        // helperText={itemErrors?.courierTrackingNo}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                        <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            name={`products.${index}.prepaidDepositAmount`}
                            label={t("payDeposit")}
                            type="text"
                            variant="outlined"
                            value={itemValues?.prepaidDepositAmount ? itemValues.prepaidDepositAmount : ""}
                            onChange={handleChange}
                            error={Boolean(itemErrors?.prepaidDepositAmount)}
                        // helperText={itemErrors?.prepaidDepositAmount}
                        />

                    </Grid>

                    <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={Boolean(itemErrors?.signUserId)}
                        >
                            <InputLabel id="signUserId">{t('signedBy')}</InputLabel>

                            <Select
                                labelId="signUserId"
                                label={t('signedBy')}
                                name={`products.${index}.signUserId`}
                                // onChange={handleChange}
                                onChange={(event) => {

                                    let userId = event.target.value

                                    // get user display
                                    let userInfo = dataAvailableWorkers.filter(i => i.user_id === userId)

                                    setFieldValue(`products.${index}.signUserId`, userId)
                                    setFieldValue(
                                        `products.${index}.signUserDisplay`,
                                        userInfo.length ? `${userInfo[0]?.firstname}${userInfo[0]?.lastname}` : ""
                                    )
                                }}
                                value={itemValues?.signUserId}
                            >
                                {
                                    dataAvailableWorkers?.map((i, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={i?.user_id}
                                            >
                                                {
                                                    `${i?.firstname}${i?.lastname} (${i?.username})`
                                                }
                                            </MenuItem>
                                        )
                                    })
                                }

                            </Select>
                            {/* <FormHelperText>
                                {touched.signUserId && errors.signUserId}
                            </FormHelperText> */}

                        </FormControl>

                    </Grid>

                    <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                        <></>

                        {/* <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            name={`products.${index}.remark`}
                            label="Remark"
                            type="text"
                            variant="outlined"
                            value={itemValues?.remark ? itemValues.remark : ""}
                            onChange={handleChange}
                            error={Boolean(itemErrors?.remark)}
                        // helperText={itemErrors?.remark}
                        /> */}

                    </Grid>

                    <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={Boolean(itemErrors?.paymentType)}
                        >
                            <InputLabel id="paymentType">{t('paymentType')}</InputLabel>
                            <Select
                                fullWidth
                                size="small"
                                // labelId="paymentType"
                                label={t('paymentType')}
                                name={`products.${index}.paymentType`}
                                onChange={handleChange}
                                value={itemValues?.paymentType}
                            >
                                {
                                    Object.keys(productPaymentTypes).map((i, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={productPaymentTypes[i].id}
                                            >
                                                <ListItemText primary={`${productPaymentTypes[i].display}`} />
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            <FormHelperText>
                                {errors?.paymentType}
                            </FormHelperText>
                        </FormControl>

                    </Grid>

                    <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                        <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            name={`products.${index}.purchaseNumber`}
                            label={t('purchaseOrderNo')}
                            type="text"
                            variant="outlined"
                            value={itemValues?.purchaseNumber ? itemValues.purchaseNumber : ""}
                            onChange={handleChange}
                            error={Boolean(itemErrors?.purchaseNumber)}
                        // helperText={itemErrors?.purchaseNumber}
                        />

                    </Grid>

                    <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                        <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            name={`products.${index}.supplierPurchaseNumber`}
                            label={t('supplierPurchaseNo')}
                            type="text"
                            variant="outlined"
                            value={itemValues?.supplierPurchaseNumber ? itemValues.supplierPurchaseNumber : ""}
                            onChange={handleChange}
                            error={Boolean(itemErrors?.supplierPurchaseNumber)}
                        // helperText={itemErrors?.supplierPurchaseNumber}
                        />

                    </Grid>

                    <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                        <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            name={`products.${index}.prepaidTransportAmount`}
                            label={t("payFreight")}
                            type="text"
                            variant="outlined"
                            value={itemValues?.prepaidTransportAmount ? itemValues.prepaidTransportAmount : ""}
                            onChange={handleChange}
                            error={Boolean(itemErrors?.prepaidTransportAmount)}
                        // helperText={itemErrors?.prepaidTransportAmount}
                        />

                    </Grid>


                    <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                        <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            name={`products.${index}.remark`}
                            label={t('remark')}
                            type="text"
                            variant="outlined"
                            value={itemValues?.remark ? itemValues.remark : ""}
                            onChange={handleChange}
                            error={Boolean(itemErrors?.remark)}
                        // helperText={itemErrors?.remark}
                        />

                    </Grid>

                    <Grid item xs={12} sm={12} md={12} alignSelf={"center"}>

                        <Divider />

                    </Grid>


                    {/* {JSON.stringify(itemValues.items)} */}

                    {
                        itemValues.items.length <= 0 ?
                            (
                                <>
                                    <Grid item xs={12} md={12} sm={12} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                        <Button
                                            fullWidth
                                            color="primary"
                                            variant="outlined"
                                            onClick={
                                                () => {

                                                    setOpenDialog({
                                                        ...openDialog,
                                                        status: true,
                                                        title: `${t('modifyItemsForEntry')} #${(index + 1)}`,
                                                        productIndex: index,
                                                        courierTrackingNo: itemValues?.courierTrackingNo,
                                                        data: itemValues?.items
                                                    })

                                                }
                                            }
                                        >
                                            <CommonIcons name={icons.plus} />
                                            <Typography>
                                                {t('addItems')}
                                            </Typography>
                                        </Button>
                                    </Grid>
                                </>
                            )
                            :
                            (
                                <>
                                    <Grid item xs={0.5} md={0.5} sm={0.5} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                        <IconButton
                                            onClick={
                                                () => {

                                                    setOpenDialog({
                                                        ...openDialog,
                                                        status: true,
                                                        title: `Modify items for Entry #${(index + 1)}`,
                                                        productIndex: index,
                                                        courierTrackingNo: itemValues?.courierTrackingNo,
                                                        data: itemValues?.items
                                                    })

                                                }
                                            }
                                        >
                                            <CommonIcons name={icons.edit} />
                                        </IconButton>
                                    </Grid>

                                    <Grid item xs={11.5} sm={11.5} md={11.5} alignSelf={"center"}>
                                        <TableContainer
                                        // component={Paper}
                                        >
                                            <Table
                                                // sx={{ minWidth: 650 }} 
                                                sx={{
                                                    "& .MuiTableCell-root": {
                                                        border: "1px solid rgba(224, 224, 224, 1)"
                                                    }
                                                }}
                                                size="small"
                                                aria-label="a dense table"
                                            >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>#</TableCell>
                                                        <TableCell>{t('model')}</TableCell>
                                                        <TableCell>{t('name')}</TableCell>
                                                        <TableCell align="right">{t('handleUnit')}</TableCell>
                                                        <TableCell align="right">{t('unitPrice')}</TableCell>
                                                        {/* <TableCell align="right">Total Value</TableCell> */}

                                                        <TableCell align="right">{t('pcsCtn')}</TableCell>
                                                        {/* <TableCell align="right">Length</TableCell>
                                                        <TableCell align="right">Width</TableCell>
                                                        <TableCell align="right">Height</TableCell> */}
                                                        <TableCell align="right">{t('dimension')}</TableCell>
                                                        <TableCell align="right">{t('packUnit')}</TableCell>

                                                        <TableCell align="right">{t('weight')}</TableCell>
                                                        <TableCell align="right">{t('uom')}</TableCell>
                                                        <TableCell align="right">{t('cbm')}</TableCell>

                                                        <TableCell align="right">{t('tValue')}</TableCell>
                                                        <TableCell align="right">{t('tWeight')}</TableCell>
                                                        <TableCell align="right">{t('tCbm')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        itemValues?.items.map((row, index2) => (
                                                            <TableRow
                                                                key={index2}
                                                            // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell>
                                                                    {(index2 + 1)}
                                                                </TableCell>
                                                                <TableCell>{row?.remark}</TableCell>
                                                                <TableCell>{row?.description}</TableCell>
                                                                <TableCell align="right">{row?.handleQty}</TableCell>
                                                                <TableCell align="right">{row?.uomPrice}</TableCell>
                                                                {/* <TableCell align="right">{row?.totalValue}</TableCell> */}

                                                                <TableCell align="right">{row?.handleQtyPerPackage}</TableCell>

                                                                <TableCell align="right">
                                                                    {row?.length} x {row?.width} x {row?.height}
                                                                </TableCell>
                                                                {/* <TableCell align="right">{row?.length}</TableCell>
                                                            <TableCell align="right">{row?.width}</TableCell>
                                                            <TableCell align="right">{row?.height}</TableCell> */}

                                                                <TableCell align="right">{row?.qty}</TableCell>

                                                                <TableCell align="right">{row?.weight}</TableCell>
                                                                <TableCell align="right">{row?.customUomName}</TableCell>
                                                                <TableCell align="right">{row?.cbm}</TableCell>
                                                                {/* 
                                                                <TableCell align="right">
                                                                    {row?.totalValue} ({t('tValue')}) /
                                                                    {row?.totalCbm} ({t('tCbm')})  /
                                                                    {row?.totalWeight} ({t('tWeight')})
                                                                </TableCell> */}


                                                                <TableCell align="right">
                                                                    {row?.totalValue}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    {row?.totalWeight}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    {row?.totalCbm}
                                                                </TableCell>

                                                            </TableRow>
                                                        ))
                                                    }
                                                    <TableRow
                                                    >
                                                        <TableCell colSpan={3} align="right">
                                                            {t("total")} :
                                                        </TableCell>

                                                        <TableCell align="right">
                                                            {grandHandleQty}
                                                        </TableCell>

                                                        <TableCell colSpan={3} align="right">
                                                            {t("total")} :
                                                        </TableCell>


                                                        <TableCell align="right">
                                                            {grandPackQty}
                                                        </TableCell>

                                                        <TableCell colSpan={3} align="right">
                                                            {t("total")} :
                                                        </TableCell>

                                                        {/* <TableCell align="right">
                                                            {itemValues?.total?.value} ({t('tValue')}) /
                                                            {itemValues?.total?.cbm} ({t('tCbm')})  /
                                                            {itemValues?.total?.weight} ({t('tWeight')})
                                                        </TableCell> */}

                                                        <TableCell align="right">
                                                            {itemValues?.total?.value}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {itemValues?.total?.weight}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {itemValues?.total?.cbm}
                                                        </TableCell>

                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Grid>
                                </>
                            )
                    }


                    {/* <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>
                        <></>
                        {JSON.stringify(itemErrors)}
                    </Grid> */}
                </Grid>
            </>
        )
    }

    const RenderFormSearchMarking = () => {
        return (
            <>
                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                    <CommonSectionHeader
                        title={t('mainInformation')}
                        subTitle={t('searchCustomerDetailsAndLocations')}
                    />

                </Grid>
                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                    <SearchCustomerMarkings
                        routeType={routeType}
                        id={`SearchCustomerMarkings`}
                        // locationId={values?.locationId}
                        config={{
                            // filterDocumentType: searchDocumentConfig?.documentType,
                            // filterKeyword: searchDocumentConfig?.keyword
                            dialogDisplayText: t('searchCustomerByMarking')
                        }}
                        // show={searchDocumentConfig?.show}
                        handleOnCancel={() => {
                            // setOpenSearchDocuments(false)
                            // setSearchDocumentConfig(prev => ({...prev, show: false}))
                        }}
                        handleOnSearchChange={(event) => {
                            // setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                        }}
                        handleOnSelect={(props) => {

                            let {
                                item
                            } = props

                            // console.log('props, props', props)

                            // setFieldValue(`marking`, 
                            // setFieldValue(`userId`, item?.user_id)
                            // setFieldValue(`userDisplay`, item?.company_name)
                            // setFieldValue(`userBranchId`, item?.id)

                            setValues({
                                ...values,
                                marking: item[markingInjectionProps.marking.retrieveKey],
                                userId: item?.user_id,
                                userDisplay: item?.company_name,
                                userBranchId: item?.id
                            })

                        }}
                        textProps={{
                            disabled: true,
                            value: values?.marking ? values.marking : "",
                            error: Boolean(errors?.userId),
                            helperText: errors?.userId
                        }}
                    />

                </Grid>

                {/* <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                    <></>
                    {
                        values?.userDisplay &&
                        <Chip
                            label={`${values?.userDisplay}`}
                            variant="outlined"
                            color="primary"
                        />
                    }


                </Grid> */}

                {/* <Grid item xs={12} sm={12} md={3} alignSelf={"center"}>

                    <CommonSectionHeader
                        title={'Customer'}
                        subTitle={"Search customer details by marking"}
                    />

                </Grid> */}
                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>
                    <FormControl
                        margin="normal"
                        fullWidth
                        size="small"
                        error={Boolean(errors?.locationId)}
                    >
                        <InputLabel id="locationId">{t('location')}</InputLabel>
                        <Select
                            labelId="locationId"
                            label={t('location')}
                            name={"locationId"}
                            onChange={(event) => {

                                let locationId = event.target.value
                                let location = availableLocations.filter(i => i.id === locationId)

                                if (location.length > 0) {
                                    setFieldValue(`locationId`, locationId)
                                    setFieldValue(`locationDisplay`, location[0]?.location_name)

                                    // reset all user id for workers
                                    // setFieldValue()
                                    let currentProducts = values.products

                                    let newProducts = currentProducts.map(i => ({
                                        ...i,
                                        signUserId: ``,
                                        signUserDisplay: ``
                                    }))

                                    setFieldValue(`products`, newProducts)

                                }

                            }}
                            value={
                                values?.locationId
                                // checkValueExists({
                                //     dataSearch: availableLocations,
                                //     valueToCompare: values.locationId
                                // })
                            }
                            sx={{
                                textAlign: 'left'
                            }}
                            disabled={
                                availableLocations.length === 1
                            }
                        >
                            {
                                availableLocations.map((i, index) => {
                                    return (
                                        <MenuItem key={index} value={i.id}>{i?.location_name}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                        <FormHelperText>
                            {errors?.locationId}
                        </FormHelperText>
                    </FormControl>
                </Grid>
            </>
        )
    }

    const RenderForm = () => {
        return (

            <form onSubmit={formik.handleSubmit}>
                <StyledCard>
                    <Grid container spacing={1}>

                        {
                            RenderFormSearchMarking()
                        }

                    </Grid>
                </StyledCard>

                <Box
                    sx={{
                        my: 1
                    }}
                >
                    <Grid container spacing={0}>
                        <Grid item xs={11} md={11} sm={11} alignSelf={"center"}>
                            <></>
                        </Grid>
                        <Grid item xs={1} md={1} sm={1} display={"flex"} justifyContent={"flex-end"} alignItems={"flex-end"}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => {

                                    // let newTabValue = values.products.length

                                    setFieldValue(
                                        `products`,
                                        [...values.products, initialProductValues]
                                    )
                                    // setTabValue(newTabValue)
                                    promptMessage(true, t('added1NewProductEntry'))
                                }}
                            >
                                <CommonIcons name={icons.plus} />
                            </Button>
                        </Grid>
                    </Grid>
                </Box>

                <Box>
                    {
                        values?.products.map((i, index) => {

                            let itemValues = i
                            let itemErrors = errors?.products

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            return (
                                <StyledCard
                                    key={index}
                                    sx={{
                                        p: 2,
                                        mb: 1
                                    }}
                                >
                                    {
                                        RenderFormProduct({
                                            itemValues,
                                            itemErrors,
                                            index
                                        })
                                    }
                                </StyledCard>
                            )
                        })
                    }
                </Box>

                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <Button
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                        >
                            {t("saveChanges")}
                        </Button>
                    </Grid>
                </Grid>
            </form>

        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newItem })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={
                    t("registerProduct")
                }
                breadcrumbs={[
                    {
                        displayText: t("products"),
                        props: {
                            href: getRoute("products/items")
                        }
                    },
                    {
                        displayText: `${t("registerProduct")} (*)`,
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />


            {/* {JSON.stringify(values)} */}

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            }


            <CommonDialog
                open={openDialog?.status}
                handleOnExit={(event, reason) => {

                    if (reason === `backdropClick`) {
                        return false
                    }

                    setOpenDialog({ ...openDialog, status: false, data: {} })

                    return true
                    // closeCustomDrawer()
                    // setRefreshDataGrid(val => val + 1)

                }}
                configs={{
                    data: openDialog?.data,
                    dialogProps: {
                        maxWidth: 'xl',
                    },
                    RenderDialogTitle: ({ data }) => {

                        // console.log('data', data);

                        return (
                            <Typography
                                sx={{
                                    fontWeight: '800'
                                }}
                            >
                                {`${openDialog?.title}`}
                            </Typography>
                        )
                    },
                    RenderDialogContent: ({ data }) => {
                        return (
                            <Box
                                sx={{
                                    p: 2,
                                    pt: 0
                                }}
                            >
                                {/* {
                                    Number(authProfileUserId) === 38 ? // masteradmin only
                                        ( */}
                                <AddProductItemsV2
                                    // documentId={data?.id}
                                    productIndex={openDialog?.productIndex}
                                    courierTrackingNo={openDialog?.courierTrackingNo}
                                    currentData={openDialog?.data}
                                    allowDeleteFirstRowAfterSave={Boolean(false)}
                                    onSaveSuccess={(currentValues, productIndex, totalSummary, isDeleteFirstRowOfSavedItems) => {

                                        setOpenDialog({ ...openDialog, status: false, data: {} })

                                        // console.log('currentValues', currentValues, totalSummary)

                                        setFieldValue(
                                            `products.${productIndex}.total`,
                                            {
                                                ...initialProductValues.total,
                                                cbm: totalSummary?.cbm,
                                                weight: totalSummary?.weight,
                                                value: totalSummary?.value
                                            }
                                        )

                                        setFieldValue(`products.${productIndex}.items`, currentValues?.items)

                                    }}
                                />
                                {/* )
                                        :
                                        (
                                            <AddProductItems
                                                // documentId={data?.id}
                                                productIndex={openDialog?.productIndex}
                                                courierTrackingNo={openDialog?.courierTrackingNo}
                                                currentData={openDialog?.data}
                                                onSaveSuccess={(currentValues, productIndex, totalSummary) => {

                                                    setOpenDialog({ ...openDialog, status: false, data: {} })

                                                    // console.log('currentValues', currentValues, totalSummary)

                                                    setFieldValue(
                                                        `products.${productIndex}.total`,
                                                        {
                                                            ...initialProductValues.total,
                                                            cbm: totalSummary?.cbm,
                                                            weight: totalSummary?.weight,
                                                            value: totalSummary?.value
                                                        }
                                                    )

                                                    setFieldValue(`products.${productIndex}.items`, currentValues?.items)

                                                }}
                                            />

                                        )
                                } */}
                            </Box>
                        )
                    }
                }}
            />


        </Box>
    )
}